import { SetDutiesPayerActionStep } from "@redotech/redo-model/advanced-flow/oms/actions";
import { RedoRadioGroup } from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const DutiesPayerRadioGroup = memo(function DutiesPayerRadioGroup({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetDutiesPayerActionStep>;
  setStep: (step: PartialWithRequiredType<SetDutiesPayerActionStep>) => void;
}) {
  return (
    <RedoRadioGroup
      options={[
        { id: "DDP", label: "Shipper paid (DDP)" },
        { id: "DAP", label: "Customer paid (DAP)" },
      ]}
      setValue={(value) => {
        setStep({ ...step, ddp: value === "DDP" });
      }}
      size="xs"
      value={step.ddp === true ? "DDP" : step.ddp === false ? "DAP" : undefined}
    />
  );
});
